import { Skeleton } from '@mui/lab';
import { Typography } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';

type Props = {
    isLoading: boolean;
    agentsNumber: number;
    minValue: number;
    maxValue: number;
};
const FilteredAgentNumber = ({
    isLoading,
    agentsNumber,
    minValue,
    maxValue,
}: Props): React.ReactElement => {
    const { t } = useTranslation();
    return (
        <>
            {isLoading ? (
                <Skeleton width="500px" height="20px" />
            ) : (
                <Typography
                    variant="h4"
                    sx={{ paddingLeft: '12px', fontSize: '16px' }}
                >
                    {t(
                        'humanResources.simulation.freeHypothesis.ifse.filteredAgentNumber',
                        {
                            count: agentsNumber,
                            agentsNumber,
                            minValue,
                            maxValue,
                        },
                    )}
                </Typography>
            )}
        </>
    );
};

export default FilteredAgentNumber;
